// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
		production: false,
		fbConfig: {
			apiKey: 'AIzaSyD0vufmt2PR_7Puosv-xatAoBB-WjGhRYM',
			authDomain: 'satpc-9f3e1.firebaseapp.com',
			databaseURL: 'https://satpc-9f3e1.firebaseio.com',
			projectId: 'satpc-9f3e1',
			storageBucket: 'satpc-9f3e1.appspot.com',
			messagingSenderId: '682296925753',
			appId: '1:682296925753:web:3b530efde518b3c5ddf7e8',
			measurementId: 'G-8D46L4W30T'
		},
		token: 'S@tPC#@!PVC'
	}
;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
